import { Component, Output, ViewChild, EventEmitter, AfterViewChecked, Input } from '@angular/core';
import { newProofSelectOptions, NewProofSelectOption } from '../members.interfaces';

declare var jQuery: any;

@Component({
  selector: 'ch-new-id-notification-modal-dialog',
  templateUrl: './new-id-notification-modal-dialog.component.html',
})
export class NewIdNotificationModalDialogComponent implements AfterViewChecked {
  @Input() public show = true;
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modal') private modal;
  loading = true;
  selectedType: string;
  proofRequestTypes: string[] = [];

  reasons: NewProofSelectOption[] = newProofSelectOptions();

  ngAfterViewChecked() {
    if (!this.show) {
      return;
    }
    jQuery(this.modal.nativeElement)
      .modal({
        backdrop: false,
      })
      .on('hidden.bs.modal', e => {
        this.close.emit(e);
      });
  }

  submitModal(): void {
    this.submit.emit(this.selectedType);
    this.closeDialog();
  }

  private closeDialog() {
    jQuery(this.modal.nativeElement).modal('hide');
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/new-id-notification-modal-dialog/new-id-notification-modal-dialog.component.ts